import { render, staticRenderFns } from "./TransportList.vue?vue&type=template&id=4ddf8105&scoped=true&"
import script from "./TransportList.vue?vue&type=script&lang=js&"
export * from "./TransportList.vue?vue&type=script&lang=js&"
import style0 from "./TransportList.vue?vue&type=style&index=0&id=4ddf8105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf8105",
  null
  
)

component.options.__file = "TransportList.vue"
export default component.exports